import { useState, useEffect, useCallback } from 'react';
import { useServices } from '@/app/providers';
import type { GuardDashboard } from '@yawi/types';

export function useGuardDashboard() {
  const { guardRepo } = useServices();
  const [dashboard, setDashboard] = useState<GuardDashboard | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setDashboard(await guardRepo.getDashboard());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar el dashboard');
    } finally {
      setLoading(false);
    }
  }, [guardRepo]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    dashboard,
    loading,
    error,
    refresh: fetchDashboard,
  };
}
